import React from 'react';
import { useDispatch } from 'react-redux';
import { enrolMockTest } from '@/actions/tests';
import { Button } from 'antd';
import { useRouter } from 'next/router';
import { setData } from '@/actions/auth';
import { isLogin } from '@/helpers/loginHelper';

const PreShowLock = ({ testStarted, setTestStarted, testData }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  const handleConfirm = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      dispatch(
        setData({
          name: 'helperObj',
          key: 'loginModal',
          value: true,
        })
      );
    } else {
      setTestStarted(true);
      const data = {
        test: testData?.id,
      };
      dispatch(enrolMockTest(data));
    }
  };

  return (
    <div className={`${!testStarted ? 'show ' : 'hide '} lock-content`}>
      <i className="fa fa-lock" aria-hidden="true"></i>
      {isLogin() ? (
        <>
          <div className="lock-text">
            Press <span className="play-btn">Start</span> to start the test
            <br />
            {testData?.isEnrolled ? (
              <>
                Press <span className="play-btn">Check Report</span> to view the
                report.{' '}
              </>
            ) : (
              ''
            )}
          </div>

          <div className={`${testData?.isEnrolled ? 'lock-text-2' : 'lock-text-1'}`}>
            <Button className="ant-btn-danger" onClick={handleConfirm}>
              Start
            </Button>{' '}
            {testData?.isEnrolled ? (
              <Button
                className="ant-btn-danger"
                onClick={() => router.push(`/mock-test/reports/${testData?.slug}`)}
              >
                Check Report
              </Button>
            ) : (
              ''
            )}
          </div>
          {testData?.isEnrolled ? (
            <>
              <div className="lock-text-1">or </div>
              <div className="lock-text-2">
                Press{' '}
                <a
                  className="play-btn"
                  onClick={() => router.push(`/mock-test/reports/${testData?.slug}`)}
                >
                  View
                </a>{' '}
                to see the report.
              </div>
            </>
          ) : (
            ''
          )}
        </>
      ) : (
        <div className="lock-text">
          Please{' '}
          <a
            className="text-secondary"
            onClick={() => {
              dispatch(
                setData({
                  name: 'helperObj',
                  key: 'loginModal',
                  value: true,
                })
              );
            }}
          >
            Login
          </a>{' '}
          first
        </div>
      )}
    </div>
  );
};

export default PreShowLock;